<template>
  <div class="hero-collage" aria-label="Hero">
    <div style="display: flex; gap: 8px;">
      <div class="tile tile--tl" style="max-width: 258px;">
        <img class="tile__img" src="../assets/images/kolase1.jpg" alt="" />
      </div>

      <div class="tile tile--tr">
        <img class="tile__img" src="../assets/images/kolase2.jpg" alt="" />
      </div>
    </div>
    <div class="tile tile--mid">
      <img class="tile__img" src="../assets/images/kolase3.jpg" alt="" />
    </div>

    <div style="display: flex; gap: 8px;">
      <div class="tile tile--quote">
        <div class="quote-card">
          <p class="quote-card__text">
            “Esensi kita berjuang di Politik agar bisa membuat kebijakan yang benar. Mempercepat Indonesia Makmur untuk Seluruh Rakyat Indonesia.”
          </p>

          <div class="quote-card__name">Angela Herliani Tanoesoedibjo</div>
          <div class="quote-card__role">Ketua Umum Partai Perindo</div>
        </div>
      </div>

      <div class="tile tile--br" style="max-width: 45%;">
        <img class="tile__img" src="../assets/images/kolase4.jpg" alt="" />
      </div>
    </div>
    </div>
</template>

<style scoped>
.hero-collage {
  width: 100%;
  max-height: calc(100vh - 20px);
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  overflow: hidden;
  gap: 8px;
}


.tile {
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  background: #eef2ff;
}

.tile--tl { grid-area: tl; }
.tile--tr { grid-area: tr; }
.tile--mid { grid-area: mid; }
.tile--quote { grid-area: quote; overflow: visible; background: transparent; }
.tile--br { grid-area: br; }

.tile__img {
  width: 100%;
  height: 100%;
  object-fit: cover;

  filter: grayscale(100%) contrast(1.05);
  opacity: 0.95;
  display: block;
}

.tile:not(.tile--quote)::after {
  content: "";
  position: absolute;
  inset: 0;
  background: rgba(37, 99, 235, 0.18); /* biru */
  pointer-events: none;
}

/* Quote card */
.quote-card {
  height: 100%;
  border-radius: 8px;
  background: #2f63d8;
  color: #fff;
  padding: 18px 18px 16px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
}

.quote-card__text {
  margin: 0;
  font-size: 14px;
  line-height: 1.55;
  opacity: 0.95;
}

.quote-card__name {
  margin-top: 6px;
  font-size: 18px;
  font-weight: 800;
}

.quote-card__role {
  font-size: 13px;
  margin-top: -8px;
  opacity: 0.9;
}
</style>
